const Heading = ({ text, className = "" }) => {
  return (
    <div
      className={`text-[20px] leading-[28px] sm:text-[40px] sm:leading-[52px] sm:tracking-[1.6px] text-black text-center font-gilroy-bold ${className}`}
    >
      {text}
    </div>
  );
};

export default Heading;
